export enum Column {
  NAME = 0,
  STATUS = 1,
  ROLE = 2,
}

export enum ColumnKeys {
  NAME = 'name',
  STATUS = 'status',
  ROLE = 'roles',
}

export enum ColumnNames {
  NAME = 'Name',
  STATUS = 'Status',
  ROLE = 'Role',
}

export interface Domain {
  _id: string;
  domainName: string;
  domainGuid: string;
  domainControllers?: DomainController[];
}

export interface DomainController {
  name: string;
  status: number;
}

export const DOMAIN_CONTROLLER_STATUS = {
  READY: 1,
  BadAuditPoliciesConfig: 2,
  Offline: 3,
  NotInstalled: 4,
  LicenseExpired: 7,
  BadCertificateAuditPoliciesConfig: 5,
};

export enum DomainControllerRoleEnum {
  DOMAIN_CONTROLLER = 'DomainController',
  CERTIFICATE_AUTHORITY = 'CertificateAuthority',
}
